// import type { IAuthState } from "./types";

// export const getUser = (state: { auth: IAuthState }) => state.auth.user;
// export const selectIsAuthenticated = (state: { auth: IAuthState }) =>
//   state.auth.isAuthenticated;
// export const selectUserRole = (state: { auth: IAuthState }) =>
//   state.auth.user?.role;
// export const selectIsAuthenticating = (state: { auth: IAuthState }) =>
//   state.auth.isAuthenticating;

// export const selectHasPaid = (state: { auth: IAuthState }) =>
//   Boolean(state.auth.user?.isPaid);
// export const getIsAuthenticating = (auth: IAuthState) => auth.isAuthenticating;

// ============================================================================
// DESTINATION:  src/store/slices/auth/authSelector.ts
// ACTION:       REPLACE your existing file
// ============================================================================

/**
 * Auth Selectors
 *
 * ============================================================================
 * WHAT CHANGED FROM YOURS
 * ============================================================================
 *   ~ getIsAuthenticating — FIXED. It took the wrong argument and always
 *     returned undefined.
 *   + getSessionVersion / getSessionType
 * Every other selector is your file, unchanged.
 */

import type { RootState } from "@/store";
import type { IAuthState } from "./types";

export const getUser = (state: { auth: IAuthState }) => state.auth.user;

export const selectIsAuthenticated = (state: { auth: IAuthState }) =>
  state.auth.isAuthenticated;

export const selectUserRole = (state: { auth: IAuthState }) =>
  state.auth.user?.role;

export const selectIsAuthenticating = (state: { auth: IAuthState }) =>
  state.auth.isAuthenticating;

export const selectHasPaid = (state: { auth: IAuthState }) =>
  Boolean(state.auth.user?.isPaid);

/**
 * ============================================================================
 * ▼ FIXED — this took `auth` and read `auth.x`; every other selector takes
 *   `state` and reads `state.auth.x`.
 * ============================================================================
 * YOURS:
 *     export const getIsAuthenticating = (auth: IAuthState) => auth.isAuthenticating;
 *
 * Called as `useSelector(getIsAuthenticating)`, React-Redux passes the ROOT
 * state, so it read `rootState.isAuthenticating` — which does not exist — and
 * returned `undefined`, always. Any `if (isAuthenticating)` guarded by it was
 * dead.
 *
 * Your guards use `selectIsAuthenticating` (the correct one), so this has been
 * harmless — but it is exported, and the next person to import the shorter name
 * inherits the bug. Same signature as everything else now.
 */
export const getIsAuthenticating = (state: { auth: IAuthState }) =>
  state.auth.isAuthenticating;

// ── session versioning ──

/**
 * THE number the invoice compares against. `null` = not asked yet. Every
 * consumer treats null as "unknown", never "changed".
 */
export const getSessionVersion = (state: RootState) =>
  state.auth.sessionVersion;

export const getSessionType = (state: RootState) => state.auth.sessionType;
